import { render } from "./FAQ2.vue?vue&type=template&id=4505baf1&scoped=true"
import script from "./FAQ2.vue?vue&type=script&lang=js"
export * from "./FAQ2.vue?vue&type=script&lang=js"

import "./FAQ2.vue?vue&type=style&index=0&id=4505baf1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4505baf1"]])

export default __exports__